import { Requests } from '@nx-smartmonkey/shared/helpers';
import configuration from '../../services/configuration';
import { sessionRepository } from '../session';
import { TranslationsRepositoryApi } from './TranslationsRepositoryApi';

const requests = Requests.create(configuration.TRANSLATIONS_BACK_END);
export const translationsRepository = new TranslationsRepositoryApi(requests, sessionRepository);
